let listenerNo = 0;
class OtherClickListener {
    constructor() {
        this.init = () => {
            window.document.documentElement.addEventListener('click', this.raiseCallBack);
        };
        this.setListener = (element, callback) => {
            listenerNo += 1;
            this.listener.push({
                callback,
                element,
                listenerNo,
            });
            return listenerNo;
        };
        this.deleteListener = (findNo) => {
            this.listener = this.listener.filter((findObj) => findNo !== findObj.listenerNo);
        };
        this.raiseCallBack = (e) => {
            const pathList = [];
            let findElement = e.target;
            while (findElement) {
                pathList.push(findElement);
                if (findElement === document) {
                    pathList.push(document);
                }
                findElement = findElement.parentElement || null;
            }
            this.listener
                .filter(({ element }) => !pathList.includes(element))
                .forEach(({ callback }) => {
                callback();
            });
        };
        this.listener = [];
    }
}
export default new OtherClickListener();
